import { useIntl } from "react-intl";
import { PricingPlanComparePlansItemFragment } from "src/graphql-types";

import { SIGNUP_CTA_URL } from "@/components/wpl/pricing/src/price-finder/constants";
import { createPlanFeatureMessages } from "@/components/wpl/pricing/src/price-finder/utils/create-price-finder-features";
import { Jfind1384PriceCard } from "@/components/wpl/pricing/src/price-finder-jfind1384/jfind-1384-price-card";
import { jiraOfferingSkus } from "@/components/wpl/pricing/src/price-finder-v3/configs";
import { useSelector } from "@/components/wpl/pricing/src/price-finder-v3/hooks.ts";
import * as selectors from "@/components/wpl/pricing/src/price-finder-v3/selectors";
import {
    usePricingPlanComparison,
    usePricingPlanCta
} from "@/components/wpl/pricing/src/pricing-content-context";
import { useLocalizedHref } from "@/libraries/web-framework";

import { DATA_PRODUCT_KEY, SignupUrlSuffix } from "./utils/constants";

export const PlanFree = () => {
    const intl = useIntl();
    const billingCycle = useSelector(selectors.getBillingCycle);

    const recommended = useSelector((ctx) =>
        selectors.isOfferingRecommended(ctx, jiraOfferingSkus.free)
    );

    // todo: localized strings (https://hello.jira.atlassian.cloud/browse/JFIND-1475)
    const freeContent: PricingPlanComparePlansItemFragment | undefined =
        usePricingPlanComparison("Free");
    const freePlanFeatureMessages = createPlanFeatureMessages(
        { free: freeContent },
        "free"
    );

    const getPricingPlanCta = usePricingPlanCta();
    const contentfulCta = getPricingPlanCta({ planName: "Free" });
    const ctaText = intl.formatMessage({
        id: "Pricing.PriceCard.Premium.CtaText",
        defaultMessage: "Get it free"
    });
    const localizedSignupURL = useLocalizedHref(SIGNUP_CTA_URL);
    const ctaUrl = `${localizedSignupURL}${SignupUrlSuffix["free"]}`;

    const planDescription = freeContent?.planOneLiner;
    const price = useSelector((ctx) => selectors.formatPrice(ctx, 0));

    return (
        <Jfind1384PriceCard
            first={true}
            highlighted={recommended}
            isRecommendedPlan={recommended}
            planName="Free"
            description={planDescription ?? ""}
            planFeatureMessages={freePlanFeatureMessages}
            ctaId={"planCtaFree"}
            ctaText={ctaText}
            ctaUrl={contentfulCta?.ctaUrl ?? ctaUrl}
            billingCycle={billingCycle}
            dataProductKey={DATA_PRODUCT_KEY}
            price={price}
            priceCalcIdx={0}
            edition="free"
        />
    );
};
